const translations = {
    basisHeading: 'Basis for % in applied mixture',
    basisUnavailable:
        'No target spray rate is recorded for this application, so there is no total tank mix volume to measure an ingredient against.',
    basisWithFigures:
        'Total tank mix volume {{totalMixVolume}}. A liquid ingredient is its % in product times the product volume divided by that total, which takes the product to weigh what the spray mixture weighs. A dry ingredient is weighed against a total mix mass of {{totalMixMass}}. Both take the spray mixture to be water at {{sprayDensity}}, and both are worked out when this report is generated.',
    carrier: 'Carrier',
    carrierComponent: '{{carrier}} (carrier)',
    component: 'Component',
    dryProduct: 'Dry product',
    liquidProduct: 'Liquid product',
    rate: 'Rate',
    tankMixComposition: 'Tank Mix Composition',
    totalAmountApplied: 'Total amount applied',
    totalTankMixVolume: 'Total tank mix volume',
    type: 'Type'
};

export default translations;
